import { Controller } from "@hotwired/stimulus"

// Contador com a faixa que cabe inteira onde o texto aparece (Google, push, cartão). Avisa, não
// trava: quem decide se passa do alvo é o editor.
export default class extends Controller {
  static targets = ["input", "count"]
  static values = { min: Number, max: Number }

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.trim().length

    this.countTarget.textContent = `${length}/${this.maxValue}`
    this.countTarget.dataset.state =
      length === 0 ? "empty" : length > this.maxValue ? "over" : length < this.minValue ? "short" : "ok"
  }
}
